"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dappRead = void 0;
var groupBy = function (xs, keySelector) {
    return xs.reduce(function (r, x) {
        var _a;
        var _b;
        var key = keySelector(x);
        return __assign(__assign({}, r), (_a = {}, _a[key] = __spreadArray(__spreadArray([], ((_b = r[key]) !== null && _b !== void 0 ? _b : []), true), [x], false), _a));
    }, {});
};
var dappRead = function (config, _fetch) {
    if (_fetch === void 0) { _fetch = fetch; }
    var evaluateContract = function (nodeApi, address, func) {
        return _fetch("".concat(nodeApi, "/utils/script/evaluate/").concat(address), {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: "{\"expr\":\"".concat(func.split("\"").join("\\\""), "\"}")
        })
            .then(function (x) { return x.json(); })
            .then(function (x) { return x.error ? Promise.reject(x) : x.result; })
            .then(function (x) {
            if (x.type === 'String')
                return parseCommaSeparated(x.value.toString());
            if (x.type === 'Tuple')
                return parseTuple(x.value);
            return undefined;
        });
    };
    var getData = function (nodeApi, address) {
        return _fetch("".concat(nodeApi, "/addresses/data/").concat(address), {
            method: 'GET',
            headers: {
                'accept': 'application/json',
            },
        })
            .then(function (x) { return x.json(); });
    };
    var configKeys = [
        'main',
        // 'admin',
        // 'pausableBy',
        'account_health_threshold',
        'account_health_overlap',
    ];
    var resrveKeys = [
        'APoint',
        'BPoint',
        'CPoint',
        'DPoint',
        'CollateralFactor',
        'ReserveFactor',
        'LiquidationThreshold',
        'LiquidationPenalty',
    ];
    var parseConfigData = function (kvp) {
        var reservesProps = kvp
            .filter(function (_a) {
            var key = _a.key;
            return resrveKeys.find(function (x) { return key.includes(x); }) !== undefined;
        })
            .map(function (x) {
            var p = x.key.split('_');
            return __assign(__assign({}, x), { id: p[0], prop: p[1] });
        });
        var configProps = kvp
            .filter(function (_a) {
            var key = _a.key;
            return configKeys.find(function (x) { return key.includes(x); }) !== undefined;
        })
            .reduce(function (a, b) {
            var _a;
            return (__assign(__assign({}, a), (_a = {}, _a[b.key] = b.value.toString(), _a)));
        }, {});
        var byReserve = Object.values(groupBy(reservesProps, function (x) { return x.id; }));
        var assets = byReserve.map(function (x) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var ABCD = [
                (_a = x.find(function (x) { return x.prop === 'APoint'; })) === null || _a === void 0 ? void 0 : _a.value.toString(),
                (_b = x.find(function (x) { return x.prop === 'BPoint'; })) === null || _b === void 0 ? void 0 : _b.value.toString(),
                (_c = x.find(function (x) { return x.prop === 'CPoint'; })) === null || _c === void 0 ? void 0 : _c.value.toString(),
                (_d = x.find(function (x) { return x.prop === 'DPoint'; })) === null || _d === void 0 ? void 0 : _d.value.toString(),
            ];
            return {
                id: x[0].id,
                ABCD: ABCD,
                reserveFactor: (_e = x.find(function (x) { return x.prop === 'ReserveFactor'; })) === null || _e === void 0 ? void 0 : _e.value.toString(),
                collateralFactor: (_f = x.find(function (x) { return x.prop === 'CollateralFactor'; })) === null || _f === void 0 ? void 0 : _f.value.toString(),
                liquidationThreshold: (_g = x.find(function (x) { return x.prop === 'LiquidationThreshold'; })) === null || _g === void 0 ? void 0 : _g.value.toString(),
                liquidationPenalty: (_h = x.find(function (x) { return x.prop === 'LiquidationPenalty'; })) === null || _h === void 0 ? void 0 : _h.value.toString(),
            };
        }).reduce(function (a, b) {
            var _a;
            return (__assign(__assign({}, a), (_a = {}, _a[b.id] = b, _a)));
        }, {});
        return __assign(__assign({}, configProps), { assets: assets });
    };
    var parseTuple = function (x) {
        return x._2.value.toString();
    };
    var parseCommaSeparated = function (x) {
        var parseValue = function (value) {
            var arr = value.split(';');
            var handleVal = function (v) {
                var x = v.trim();
                if (x.toLowerCase() === 'true')
                    return true;
                if (x.toLowerCase() === 'false')
                    return false;
                return x;
            };
            return arr.length > 1 ? arr.map(handleVal) : handleVal(value);
        };
        return x.split(',').map(function (x) { return x.split(':'); }).reduce(function (a, _a) {
            var _b;
            var key = _a[0], value = _a[1];
            return (__assign(__assign({}, a), (_b = {}, _b[key.trim()] = parseValue(value), _b)));
        }, {});
    };
    var evaluateReserves = function (_a) {
        var _b = _a.config, assets = _b.assets, nodeApi = _b.nodeApi, functionToEvaluate = _a.functionToEvaluate, assetIds = _a.assetIds;
        return Promise.all(Object.entries(assets).filter(function (_a) {
            var _ = _a[0], asset = _a[1];
            return assetIds ? assetIds.includes(asset.id) : true;
        })
            .map(function (_a) {
            var id = _a[0], reserveAddress = _a[1].reserveAddress;
            return evaluateContract(nodeApi, reserveAddress, functionToEvaluate).then(function (r) { return (__assign({ id: id }, r)); });
        }))
            .then(function (x) { return x.reduce(function (a, v) {
            var _a;
            return (__assign(__assign({}, a), (_a = {}, _a[v.id] = v, _a)));
        }, {}); });
    };
    var getAssetPrice = function (_a) {
        var config = _a.config, assetIds = _a.assetIds;
        return Promise.all(Object.keys(config.assets)
            .filter(function (assetId) { return assetIds ? assetIds.includes(assetId) : true; })
            .map(function (assetId) { return evaluateContract(config.nodeApi, config.oracle, "price(\"".concat(assetId, "\")")).then(function (x) { return ({ id: assetId, value: x }); }); })).then(function (x) { return x.reduce(function (a, v) {
            var _a;
            return (__assign(__assign({}, a), (_a = {}, _a[v.id] = v.value, _a)));
        }, {}); });
    };
    return {
        getAssetPrice: function (assetIds) { return getAssetPrice({ config: config, assetIds: assetIds }); },
        //getConfig: (assetIds?: string[]) => evaluateReserves<Config>({ config, functionToEvaluate: 'getConfig()', assetIds }),
        getConfig: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getData(config.nodeApi, config.config)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, parseConfigData(data)];
                }
            });
        }); },
        getState: function (assetIds) { return evaluateReserves({ config: config, functionToEvaluate: 'getState()', assetIds: assetIds }); },
        getUserState: function (userAddress, assetIds) { return evaluateReserves({ config: config, functionToEvaluate: "getUserState(\"".concat(userAddress, "\")"), assetIds: assetIds }); }
    };
};
exports.dappRead = dappRead;
//# sourceMappingURL=dappRead.js.map